import * as swcHelpers from '@swc/helpers';
import { fromStoreGroupQueryDataToStores } from './adapters.js';
import { GET_STORE_GROUP } from './queries.js';

function getPageData(apolloClient, groupName, locale) {
    return _getPageData.apply(this, arguments);
}
function _getPageData() {
    _getPageData = swcHelpers.asyncToGenerator(function*(apolloClient, groupName, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_STORE_GROUP,
                variables: {
                    groupName
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeGroupQueryData = data.stores;
            const stores = fromStoreGroupQueryDataToStores(storeGroupQueryData);
            if (error) {
                console.error(error);
            }
            if (!stores) {
                return null;
            }
            return {
                stores
            };
        } catch (e) {
            console.error(e);
            return null;
        }
    });
    return _getPageData.apply(this, arguments);
}

export { getPageData };
//# sourceMappingURL=data.js.map
